import React from 'react';
import { Alert } from 'flowbite-react';
import { HiInformationCircle } from 'react-icons/hi';
import { TFunction } from 'i18next';
import { AlertContentVisibility } from '../../Shared/AlertContentVisibility';

interface SessionValidationAlertProps {
  t: TFunction<'translation', undefined>;
  errors: string[];
  isModalForAdd: boolean;
}

export const SessionValidationAlert: React.FC<SessionValidationAlertProps> = ({
  t,
  errors,
  isModalForAdd,
}) => {
  if (!errors || errors.length === 0) {
    return null;
  }

  return (
    <Alert
      className={`m-auto mt-3 w-11/12`}
      withBorderAccent
      additionalContent={<AlertContentVisibility t={t} errors={errors} />}
      color="warning"
      icon={HiInformationCircle}
    >
      <span className="me-1 ms-1 font-extrabold">{t('alert.info')}</span>
      {isModalForAdd
        ? t('alert.sessionAddMessage')
        : t('alert.sessionEditMessage')}
    </Alert>
  );
};
